export const closeExpiredModal = () => {
    localStorage.setItem('expiredModalClosed', 'true');
};
export const refreshExpiredModal = () => {
    localStorage.removeItem('expiredModalClosed');
};
export const getExpiredModalClosed = () => {
    return localStorage.getItem('expiredModalClosed') === 'true';
};
